import { useTranslation } from "react-i18next";
import Pack from "../Pack";
import ButtonBtn from "../buttons/ButtonBtn";
import styles from "../../css/reviews/Sections.module.css";
import base from "../../css/reviews/Reviews.module.css";

// PLACEHOLDER ikony – vyměnit za vlastní ikony widgetu
import publishIcon from "../../img/banner/publish.svg";
import growIcon from "../../img/banner/grow.svg";
import clockIcon from "../../img/banner/clock.svg";
import userIcon from "../../img/banner/user.svg";

const icons = [publishIcon, growIcon, clockIcon, userIcon];

const WhatItCanDoReviews = ({ onCtaClick }) => {
  const { t } = useTranslation();
  const content = t("reviews.whatItCanDo", { returnObjects: true });

  return (
    <Pack dataComponent={"what-it-can-do-reviews"}>
      <h2 className={`title ${base.heading}`}>{content.heading}</h2>
      {content.lead && <p className={styles.lead}>{content.lead}</p>}
      <div className={styles.grid}>
        {Array.isArray(content.texts) &&
          content.texts.map((item, index) => (
            <div key={index} className={styles.card}>
              <span className={styles.cardIconWrap}>
                <img
                  className={styles.cardIcon}
                  src={icons[index % icons.length]}
                  alt=""
                />
              </span>
              <h3>{item.title}</h3>
              {item.text && <p>{item.text}</p>}
            </div>
          ))}
      </div>
      <div className={styles.center}>
        <ButtonBtn
          onClick={(e) => {
            e.target.blur?.();
            onCtaClick?.();
          }}
          style={{ marginTop: "35px", marginInline: "auto" }}
          hoverBg={"white"}
          hoverColor={"black"}
        >
          {content.btn}
        </ButtonBtn>
      </div>
    </Pack>
  );
};

export default WhatItCanDoReviews;
